// tslint:disable:no-empty
import moment from 'moment-timezone';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { getRange } from '../lib/qualaRange';

const TimeContext = React.createContext({
  timeScale: 'month' as TimeRange,
  targetDate: new Date(),
  range: getRange(new Date(), 'month'),
  formattedRange: getRange(new Date(), 'month').formattedRange(),
  prev: () => {},
  next: () => {},
  isCurrentRange: true,
  setTimeScale: (value: TimeRange) => {}
});

interface TimeProviderArgs {
  children: React.ReactNode;
  initialTimeScale?: TimeRange;
}

const TimeProvider: React.FC<TimeProviderArgs> = ({ children, initialTimeScale = 'month' }) => {
  const [timeScale, setTimeScale] = useState(initialTimeScale);
  const [targetDate, setTargetDate] = useState(new Date());

  const timeValue = {
    timeScale,
    targetDate,
    range: getRange(targetDate, timeScale),
    formattedRange: getRange(targetDate, timeScale).formattedRange(),
    prev: handlePrev,
    next: handleNext,
    isCurrentRange: moment(targetDate)
      .add(1, timeScale)
      .isAfter(new Date()),
    setTimeScale: (value: TimeRange) => handleTimeScaleChange(value)
  };

  async function handleTimeScaleChange(value: TimeRange) {
    setTimeScale(value);
  }

  function handlePrev(): void {
    const prevTargetDate = moment(targetDate)
      .subtract(1, timeScale)
      .toDate();
    setTargetDate(prevTargetDate);
  }

  function handleNext(): void {
    const nextTargetDate = moment(targetDate)
      .add(1, timeScale)
      .toDate();
    setTargetDate(nextTargetDate);
  }

  useEffect(() => {
    const values = queryString.parse(window.location.search);

    if (values) {
      if (values.targetDate && targetDate.toISOString() !== values!.targetDate) {
        setTargetDate(new Date(values.targetDate! as string));
      }

      if (values.timeScale && timeScale !== values!.timeScale) {
        const timeScaleInput = values.timeScale as TimeRange;
        if (['month', 'year', 'week'].includes(timeScaleInput)) {
          setTimeScale(timeScaleInput);
        }
      }
    }
  }, [targetDate, timeScale]);

  return <TimeContext.Provider value={timeValue}>{children}</TimeContext.Provider>;
};

export { TimeContext, TimeProvider };
